import { Reveal } from "./Reveal";

const EmptyNote = ({ text }) => (
  <li className="flex flex-wrap items-center justify-between gap-3 border-b border-bv-line/70 py-4 last:border-0">
    <span className="font-mono text-xs uppercase tracking-[0.18em] text-bv-faint">{text}</span>
    <span className="chip !px-3 !py-1">Editable</span>
  </li>
);

const ACCENTS = { flame: "bg-bv-flame", gold: "bg-bv-gold", sky: "bg-bv-sky", pink: "bg-bv-pink" };

const ItemRow = ({ item }) => (
  <li className="group flex items-baseline justify-between gap-4 border-b border-bv-line/70 py-4 last:border-0">
    <span className="transition-transform duration-200 group-hover:translate-x-1.5">
      {item.accent && ACCENTS[item.accent] && (
        <span
          className={`mr-2.5 inline-block h-2 w-2 rotate-45 align-middle ${ACCENTS[item.accent]}`}
          aria-hidden="true"
        />
      )}
      <span className="font-semibold text-bv-ink sm:text-lg">{item.name}</span>
      {item.style && <span className="text-bv-sub"> — {item.style}</span>}
    </span>
    {item.note && (
      <span className="hidden shrink-0 font-mono text-[10px] uppercase tracking-[0.15em] text-bv-faint sm:block">
        {item.note}
      </span>
    )}
  </li>
);

// Typography-driven printed-menu section — no photography, ever.
export default function MenuSection({ index, id, title, tagline, items = [], groups = null, note }) {
  return (
    <Reveal>
      <section id={id} data-testid={`menu-section-${id}`} className="scroll-mt-32">
        <div className="mb-6 flex items-center gap-4">
          <span className="font-mono text-xs font-bold text-bv-faint">{String(index).padStart(2, "0")}</span>
          <h2 className="font-display text-3xl uppercase text-bv-ink sm:text-4xl">{title}</h2>
          <span className="h-px flex-1 bg-bv-line" aria-hidden="true" />
          {tagline && (
            <span className="hidden font-mono text-[10px] uppercase tracking-[0.2em] text-bv-faint md:block">
              {tagline}
            </span>
          )}
        </div>

        {groups ? (
          <div className="grid gap-8 md:grid-cols-2">
            {groups.map((g) => (
              <div key={g.label}>
                <h3 className="mb-1 font-mono text-xs font-bold uppercase tracking-[0.22em] text-bv-flame">
                  {g.label}
                </h3>
                <ul>
                  {g.items.map((it, i) => (
                    <ItemRow key={`${g.label}-${it.name}-${i}`} item={it} />
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ) : (
          <ul>
            {items.length ? (
              items.map((it, i) => <ItemRow key={`${it.name}-${i}`} item={it} />)
            ) : (
              <EmptyNote text={note || "Selection being finalized"} />
            )}
          </ul>
        )}

        {items.length > 0 && note && (
          <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.15em] text-bv-faint">{note}</p>
        )}
      </section>
    </Reveal>
  );
}
